<template>
  <div>
    <md-card class="card-container">
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <page-title :title="'服務項目列表'"></page-title>
        </div>
      </div>
      <div>
        <div class="md-layout md-gutter">
          <div class="md-layout-item">
            <md-field>
              <label>物品名稱</label>
              <md-input v-model="data.name"></md-input>
            </md-field>
          </div>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-button class="md-raised md-danger" @click="clearAll">清除搜尋結果</md-button>
          <md-button class="md-raised md-primary" @click="$router.push('/item/add')">新增物品</md-button>
        </div>
        <div class="md-layout-item">
          <md-button class="float-right md-raised md-primary" @click="getItems()">搜尋</md-button>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-table>
            <md-table-row>
              <md-table-head>名稱</md-table-head>
              <md-table-head>價格</md-table-head>
            </md-table-row>
            <md-table-row v-for="(item, index) in items" :items="items" :key="item.id">
              <md-table-cell>
                <router-link :to="`/item/${item.id}`">
                  {{item.name}}
                </router-link>
              </md-table-cell>
              <md-table-cell>
                {{item.price}}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <paginate
            :page-count="Math.ceil(pageCount / 20)"
            :click-handler="getItems"
            :prev-text="'前頁'"
            :next-text="'下頁'"
            :container-class="'pagination'"
            :no-li-surround="true"
          >
          </paginate>
        </div>
      </div>
    </md-card>
  </div>
</template>

<script>
import PageTitle from '@/components/Shared/PageTitle'
import axios from 'axios'
import urls from '@/urls'
import Paginate from 'vuejs-paginate'

export default {
  data () {
    return {
      pageCount: 0,
      data: {
        name: null
      },
      items: []
    }
  },
  components: {
    PageTitle, Paginate
  },
  created () {
    this.getItems()
  },
  methods: {
    clearAll: async function () {
      this.items = []
    },
    getItems: async function (page = 1) {
      for (var i in this.data) {
        if (this.data[i] === '') {
          this.data[i] = null
        }
      }
      let req = await axios.get(urls({route: 'item'}), {params: {...this.data, page}})
      this.items = req.data.data
      this.pageCount = req.data.count
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Item/ItemList.vue